var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useField } from '../../hook/field.hook';
import { useOptions } from '../../hook/options.hook';
import { useVisibility } from '../../hook/visibility.hook';
var FormField = function (_a) {
    var defaultProps = _a.defaultProps, specificProps = _a.specificProps, Component = _a.Component;
    var fieldIsVisible = useVisibility(defaultProps.name).fieldIsVisible;
    var reset = useField(defaultProps.name).reset;
    var options = useOptions(defaultProps.name).options;
    var specificPropsOverride = options && options.length ? __assign(__assign({}, specificProps), { options: options }) : specificProps;
    return React.createElement(Component, __assign({}, defaultProps, specificPropsOverride, { visible: fieldIsVisible, reset: reset }));
};
export default FormField;
//# sourceMappingURL=index.js.map